import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import type * as Highcharts from 'highcharts';
import { HighchartsChartComponent, providePartialHighcharts } from 'highcharts-angular';

import { ROOM_UTILIZATION_HEATMAP_ESTIMATED_TOOLTIP } from './room-utilization-charts';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DecimalPipe, HighchartsChartComponent, MatIcon, MatTooltip],
  providers: [
    providePartialHighcharts({
      modules: () => [import('highcharts/esm/modules/heatmap')],
    }),
  ],
  selector: 'avs-room-utilization-heatmap-chart',
  templateUrl: './room-utilization-heatmap-chart.component.html',
})
export class RoomUtilizationHeatmapChartComponent {
  chartOptions = input.required<Highcharts.Options>();
  estimated = input(false);
  maxValue = input.required<number>();

  protected readonly estimatedTooltip = ROOM_UTILIZATION_HEATMAP_ESTIMATED_TOOLTIP;
}
